import { FC, memo } from 'react'
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface FileInputProps {
    label: string;
    value: File | null;
    onChange: (val: File | null) => void;
    required?: boolean;
    helperText?: string;
}

const FileInput: FC<FileInputProps> = ({ label, value, onChange, required = false, helperText }) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className="input-holder">
            <label>{label}{required ? '*' : ''}</label>
            <input
                type="file"
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e.target.files ? e.target.files[0] : null)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                required={required}
                disabled={disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
            />
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(FileInput)

